import api from "@/lib/axiosConfig";
import type { BatchImportType } from "@/components/batch-import/batchImportConfig";

export interface CreatedFiche {
  id: string;
  registrationNumber: string;
  title: string;
  type: BatchImportType;
}

/** Crée une fiche minimale (titre + n° d'enregistrement temporaire) pour l'import. */
export async function createFicheFromImport(
  type: BatchImportType,
  title: string,
): Promise<CreatedFiche> {
  const { data } = await api.post<CreatedFiche>(
    `back/api/batch-import/${type}/create-fiche`,
    { title },
  );
  return data;
}

/** Rollback : supprime une fiche importée dont l'upload/conversion a échoué. */
export async function rollbackImportedFiche(
  type: BatchImportType,
  id: string,
): Promise<void> {
  await api.delete(`back/api/batch-import/${type}/${id}`);
}
